import {
  useAxios,
  useHandleApiError,
} from '@sttedra_ui/framework';

import RouteStopApiResponseModel from './route-stop.api-response-model.js';

// #region Globals
const {base} = useAxios();
const DEFAULT_TIMEOUT = 5000;
const {handleApiError} = useHandleApiError();
// #endregion
// #region Public functions

async function searchRouteStop(name, throwError = true) {
  try {
    const jsonModel = {
      name: name,
    };
    const url = '/lugardestino';

    const {data} = await base.post(url, jsonModel, {
      timeout: DEFAULT_TIMEOUT,
    });
    const dataFinal = data.map((u) => new RouteStopApiResponseModel(u));
    return dataFinal;
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  searchRouteStop,
};
